"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCategory = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var react_router_1 = require("react-router");
var useCategory = function () {
    var _a = (0, react_1.useState)(), categoryDatas = _a[0], setCategoryDatas = _a[1];
    var _b = (0, react_1.useState)([]), productDatas = _b[0], setProductDatas = _b[1];
    var _c = (0, react_1.useState)(), paginateData = _c[0], setPaginateData = _c[1];
    var _d = (0, react_1.useState)(true), isCategoryLoading = _d[0], setIsCategoryLoading = _d[1];
    var params = (0, react_router_1.useParams)();
    var nextScroll = function () {
        (paginateData === null || paginateData === void 0 ? void 0 : paginateData.next_page_url) &&
            axios_1.default.get(paginateData.next_page_url).then(function (response) {
                setProductDatas(__spreadArray(__spreadArray([], productDatas, true), response.data.products, true));
                setPaginateData(response.data.paginate);
            });
    };
    (0, react_1.useEffect)(function () {
        Promise.resolve()
            .then(function () {
            return axios_1.default.get("/api/categories/" + params.shop_code + "/" + params.category_id);
        })
            .then(function (response) {
            setCategoryDatas(response.data);
            return axios_1.default.get("/api/products/" + params.shop_code + "?category_id=" + response.data.category_id);
        })
            .then(function (response) {
            setProductDatas(response.data.products);
            setPaginateData(response.data.paginate);
        })
            .finally(function () {
            setIsCategoryLoading(false);
        });
    }, []);
    return {
        categoryDatas: categoryDatas,
        productDatas: productDatas,
        paginateData: paginateData,
        nextScroll: nextScroll,
        isCategoryLoading: isCategoryLoading,
    };
};
exports.useCategory = useCategory;
